import baseAPI from '@/http'

const router = 'api/seloClienteOcultoResposta'

export const seloClienteOcultoRespostaAPI = {

  list: (municipioId) => baseAPI.get(`${router}/obter-cliente-oculto-resposta-por-municipio/${municipioId}`),
  atualizar: (resposta) => baseAPI.put(`${router}/atualizar-cliente-oculto-resposta`, resposta),
  delete: (respostaId) => baseAPI.delete(`${router}/${respostaId}`),
  enviarAnalise: (municipioId) => baseAPI.put(`${router}/setar-enviada/${municipioId}`),
  downloadPdf: (municipioId) => baseAPI.get(`${router}/selo-cliente-oculto-pdf-by-municipioId/${municipioId}`, { responseType: 'blob' }),
  getRespostaPergunta: (perguntaId, municipioId) => baseAPI.get(`${router}/obter-cliente-oculto-resposta-por-pergunta-municipio/${perguntaId}/${municipioId}`),
  reabrirCliente: (municipioId) => baseAPI.put(`${router}/reabrir-cliente/${municipioId}`),

}
